var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one_row_title",style:({ margin: _vm.margin })},[_c('div',{staticClass:"cs_line"}),_c('div',{staticClass:"title_style"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"cs_line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }